import React from 'react';

import { formatCurrency } from '@coingecko/cryptoformat';
import ArticleIcon from '@mui/icons-material/Article';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import GitHubIcon from '@mui/icons-material/GitHub';
import LanguageIcon from '@mui/icons-material/Language';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { IconButton, Tooltip, Stack, Typography } from '@mui/material';

import { CopyToClipBoard, RowStack } from '../../common_components';
import { DiscordIcon } from '../../Icons/DiscordIcon';
import { MediumIcon } from '../../Icons/MediumIcon';

export const TokenInfo = ({
  contract_address,

  launch_mkt_cap,
  initial_supply,
  ido_price,
  social_handles,
  wallets
}) => {
  const {
    twitter_url,
    telegram_url,
    github_url,
    website_url,
    whitepaper_url,
    discord_url,
    medium_url
  } = social_handles[0];

  return (
    <>
      <Stack>
        <Stack>
          <Stack direction="row" sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body2" gutterBottom sx={{ mr: 2 }}>
              Contract:
            </Typography>
            {contract_address && (
              <Typography variant="body2" gutterBottom>
                {`${contract_address?.substr(0, 5)}...${contract_address?.substr(
                  contract_address?.length - 5
                )}`}
                {contract_address ? (
                  <CopyToClipBoard>
                    {({ copy }) => (
                      <IconButton onClick={() => copy(contract_address)}>
                        <CopyAllIcon />
                      </IconButton>
                    )}
                  </CopyToClipBoard>
                ) : null}
              </Typography>
            )}
          </Stack>
          <RowStack
            field="Initial Price :"
            value={ido_price && formatCurrency(ido_price, 'USD', 'en', false)}
          />
          <RowStack
            field="Initial Mcap :"
            value={launch_mkt_cap && formatCurrency(launch_mkt_cap, 'USD')}
          />
          <RowStack
            field="Initial Supply :"
            value={initial_supply?.toLocaleString(undefined, { minimumFractionDigits: 0 })}
          />

          <RowStack field="Wallets: " value={wallets.map((item) => item.wallet_name).join(',')} />

          <Stack direction="row">
            {twitter_url ? (
              <Tooltip title="Twitter">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={twitter_url ? false : true}
                  href={twitter_url}
                  target="_blank">
                  <TwitterIcon sx={{ color: twitter_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}
            {telegram_url ? (
              <Tooltip title="Telegram">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={telegram_url ? false : true}
                  href={telegram_url}
                  target="_blank">
                  <TelegramIcon sx={{ color: telegram_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}

            {website_url ? (
              <Tooltip title="Webiste">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={website_url ? false : true}
                  href={website_url}
                  target="_blank">
                  <LanguageIcon sx={{ color: website_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}
            {whitepaper_url ? (
              <Tooltip title="WhitePaper">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={whitepaper_url ? false : true}
                  href={whitepaper_url}
                  target="_blank">
                  <ArticleIcon sx={{ color: whitepaper_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}

            {github_url ? (
              <Tooltip title="GitHub">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={github_url ? false : true}
                  href={github_url}
                  target="_blank">
                  <GitHubIcon sx={{ color: github_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}
            {discord_url ? (
              <Tooltip title="Discord">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={discord_url ? false : true}
                  href={discord_url}
                  target="_blank">
                  <DiscordIcon sx={{ color: discord_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}
            {medium_url ? (
              <Tooltip title="Medium">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  disabled={medium_url ? false : true}
                  href={medium_url}
                  target="_blank">
                  <MediumIcon sx={{ color: medium_url ? '#3d79e9' : '#c1bfbf' }} />
                </IconButton>
              </Tooltip>
            ) : null}
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
